import { createGlobalStyle, css } from "styled-components";

export const HideBodyVerticalScroll = createGlobalStyle`
  body {
    overflow-y: hidden !important;
  }
`;

export const scrollerStyle = () => css`
  &::-webkit-scrollbar {
    border-radius: 16px;
    height: 9px;
    width: 9px;
    background-color: ${({ theme }) => theme?.colors?.neutral.neutral40};
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 16px;
    background-color: ${({ theme }) => theme?.colors?.primary.default};
  }
`;

export const invisibleScroll = () => css`
  &::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none;
  scrollbar-width: none;
`;

// use with hook "useToggleShowScroll()" to get the showScroll
export const transparentScrollStyle = ({ showScroll }: { showScroll?: boolean }) => {
  return css`
    &::-webkit-scrollbar {
      border-radius: 16px;
      height: 9px;
      width: 4px;
      background-color: ${({ theme }) =>
        showScroll ? theme.colors.neutral.neutral40 : "transparent"};
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 16px;
      background-color: ${({ theme }) =>
        showScroll ? theme.colors.primary.default : "transparent"};
    }
  `;
};

export const floatingScrollStyle = () => css`
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.neutral.neutral50};
    border-radius: 4px;
  }
`;

export const flatScrollStyle = () => css`
  &::-webkit-scrollbar {
    width: 4px;
    background: #e6e6e6;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.primary.default};
    border-radius: 0px;
  }
`;
